import ClientContext from "@contexts/Client.context";
import { 
  useFetch,
  useConfigurationContext,
} from "@hooks/index";

import { 
  QueryClient, 
  QueryClientProvider,
} from "@tanstack/react-query";

const queryClient = new QueryClient();

const ClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => {  
  const config = useConfigurationContext();
  const client = useFetch(config);
  
  if (!config) {
    throw new Error("ClientProvider must be used within an ConfigurationProvider");
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ClientContext.Provider value={client}>
        {children}
      </ClientContext.Provider>
    </QueryClientProvider>
  );
};

export default ClientProvider;
